"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const package_json_1 = require("./package.json");
exports.default = package_json_1.version;
